import { render } from "./LeadMgmt.vue?vue&type=template&id=ffb6529c&scoped=true"
import script from "./LeadMgmt.vue?vue&type=script&lang=js"
export * from "./LeadMgmt.vue?vue&type=script&lang=js"

import "./LeadMgmt.vue?vue&type=style&index=0&id=ffb6529c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb6529c"]])

export default __exports__